import { Component, ViewChild } from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {HttpClient} from "@angular/common/http";
import {PointService} from "../../../shared/services/point.service";
import {
    CustomNotificationFormComponent
} from "../app-management/custom-notification-form/custom-notification-form-component";
import { AddPointComponent } from "./add-point/add-point-component";
import { CTableComponent } from "../../../core/ui/c-table/c-table.component";
import AppShareHelper from "../../../shared/utils/helper";

@Component({
    selector: 'app-point-management',
    templateUrl: './point-management.html',
})
export class PointManagement {
    constructor(protected http: HttpClient,
                public toastr : ToastrService,
                protected _modalService: NgbModal) {
    }

    ngOnInit() {

    }
    
    @ViewChild('ticketRankingListView')
    ticketRankingListView: CTableComponent;
    
    addTicketPopup() {
        const modal = this._modalService.open(AddPointComponent, {centered: true, size: 'sm'});
        modal.componentInstance.onRefresh.subscribe((e)=> {
            this.ticketRankingListView.refresh();
        })
    }

    ticketRankingList = {
        useLocalTable: false,
        usePaging: true,
        isAutoload: true,
        pagingOptions: {
            showTotalRecords: true,
            pageSizes: [100, 200, 300],
            pageSize: 100,
            currentPage: 1
        },
        columnDefs: [
            {
                cellClass: 'text-capitalize',
                displayName: '#',
                field: 'index',
            },
            {
                cellClass: 'text-capitalize',
                displayName: 'Name',
                field: 'customerName',
            },
            {
                cellClass: 'text-capitalize',
                displayName: 'UserId',
                field: 'customerId',
            },
            {
                cellClass: 'text-capitalize',
                displayName: 'Number of raw tickets',
                field: 'accumulationPoint',
            },
            {
                cellClass: 'text-capitalize',
                displayName: 'Number of displayed tickets',
                field: 'accumulationDisplayedPoint',
            },
        ],
        extraData: {
            openDetail : (entity) =>{

            },
        },

        refresh: (params, table) => {
            let paging = {
                skip: (params._page - 1) * params._pageSize,
                limit: params._pageSize,
                order: 'accumulationPoint DESC',
                include: ['customer'],
                where: {
                    eventId : 1
                }
            };

            let pagingUrl = encodeURIComponent(JSON.stringify(paging));
            this.http.get(PointService.eventPointRankingAPI + `?filter=${pagingUrl}`, {observe: "response"})
                .subscribe(
                    (res: any) => {
                        if (res.body.Data && res.body.Data.length) {
                            let index = 1;
                            res.body.Data.forEach(item => {
                                item.customerName =  item.customer.fullName;
                                item.accumulationDisplayedPoint = AppShareHelper.getNumberOfTicketByAccessLevel(item.accumulationPoint, item.customer.accessLevel);
                                item.index = index;
                                index++;
                            })
                            table.setData(res.body.Data, res.headers.get('X-Total-Count'));
                        } else {
                            table.setData([], 0);
                        }
                    },
                    (error) => {
                        this.toastr.error(error.error.Message, 'Error');
                    }
                );
        }
    }
}
